import React, { useEffect, useState, useRef } from 'react';
import { Col } from 'react-bootstrap';

import { Button, Modal, Text } from 'v3/components';
import ManualRegisterWagon from '../ManualRegisterWagon';
import OcrRegisterWagon from '../WagonRegisterOcr';

export function RegisterWagon({
  isOpen,
  onClose,
  wagonKey,
  sendResponse
}) {

  const manualRef = useRef(null);
  const ocrRef = useRef(null);

  const [manualRegister, setManualRegister] = useState(false)
  const [frontImageCrlv, setFrontImageCrlv] = useState([]);
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  async function handleSave() {
    if (manualRegister) {
      await manualRef.current?.save();
    } else {
      await ocrRef.current?.save();
    }
  }

  const handleClose = () => {
    onClose();
    setData({});
    setFrontImageCrlv([]);
    setErrors({});
    setManualRegister(false);
  }

  useEffect(() => {
    setData({});
    setFrontImageCrlv([]);
    setErrors({});
  }, [manualRegister])

  return (
    <Modal
      show={isOpen}
      handleClose={handleClose}
      heading={
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            gap: 16,
            justifyContent: 'space-between',
            paddingRight: 32,
            width: '100%',
          }}
        >
          <Text type="header" color="dark" weight="500">
            Cadastrar Implemento
          </Text>
          <Button
            className="py-2"
            onClick={() => setManualRegister(!manualRegister)}
          >
            <Text weight="500" type="regular">
              {!manualRegister ? 'Cadastro manual' : 'Importar implemento'}
            </Text>
          </Button>
        </div>
      }
      body={
        <>
          {manualRegister ? (
            <ManualRegisterWagon
              ref={manualRef}
              data={data}
              setData={setData}
              errors={errors}
              setErrors={setErrors}
              setLoading={setLoading}
              wagonKey={wagonKey}
              sendResponse={sendResponse}
              handleClose={handleClose}
            />
          ) : (
            <OcrRegisterWagon
              ref={ocrRef}
              data={data}
              setData={setData}
              frontImageCrlv={frontImageCrlv}
              setFrontImageCrlv={setFrontImageCrlv}
              handleClose={handleClose}
              errors={errors}
              setErrors={setErrors}
              setSaveLoading={setLoading}
              saveLoading={loading}
              wagonKey={wagonKey}
              sendResponse={sendResponse}
            />
          )}
        </>
      }
      footer={
        <Col
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            marginTop: 16,
            marginBottom: 32,
          }}
        >
          <Button
            variant="secondary"
            onClick={handleClose}
            loading={loading}
          >
            <Text color="dark" type="regular">
              Voltar
            </Text>
          </Button>
          <Button
            variant="success"
            onClick={handleSave}
            loading={loading}
          >
            <Text weight={500} color="white" type="regular">
              Salvar
            </Text>
          </Button>
        </Col>
      }
    />
  );
}
